import { DataDisplayEvent } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutFactoringCompanySummaryQuickInfo } from "./autogen/AutogenLayoutFactoringCompanySummaryQuickInfo";

export class FactoringCompanySummaryQuickInfo extends AutogenLayoutFactoringCompanySummaryQuickInfo {

    textboxCodeOnDataDisplay(event: DataDisplayEvent) {
        this.textboxCode.printableLabel.link = LayoutUrl.createForUpdateMode(
            "lme/settlement/FactoringCompany",
            event.rowData?.get("id")
        );
    }
}
